<div class="table">
  <div class="card">
    <h3 *ngIf="!updateMode">{{ preferenceMessages.tab_5_label_2 | translate }}</h3>
    <h3 *ngIf="updateMode && isGestionComptesAnnonceur">{{ preferenceMessages.tab_5_label_2_bis | translate }}</h3>
    <form class="form" [formGroup]="form">
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_5_label_identifiant | translate" [type]="'text'"
        [rule]="''" [name]="'preference_SepAtt_annonceur_SepAtt_identifiant'" [disabled]="!isGestionComptesAnnonceur">
      </app-form-input>
      <app-form-input [parentForm]="form" [label]="preferenceMessages.tab_5_label_emailboamp | translate" [type]="'email'"
        [rule]="''" [name]="'preference_SepAtt_annonceur_SepAtt_emailboamp'" [disabled]="!isGestionComptesAnnonceur">
      </app-form-input>
      <div class="buttonsGroup">
        <button *ngIf="!updateMode && isGestionComptesAnnonceur" id="ajouter" [disabled]="(!form.valid)" (click)="savePref()"
          class="btn btn-primary">
          {{ preferenceMessages.tab_5_label_ajouter | translate }}
        </button>
        <button *ngIf="updateMode && isGestionComptesAnnonceur" id="ajouter" [disabled]="(!form.valid)" (click)="savePref()" class="btn btn-primary">
          {{ preferenceMessages.tab_5_label_modifier | translate }}
        </button>
        <button *ngIf="isGestionComptesAnnonceur" id="annuler" (click)="annuler()" class="btn btn-outline-primary">
          {{ preferenceMessages.tab_5_label_annuler | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
